<script>
	export default {
		name: 'LinkExecuter',
		methods: {
			openLink(link) {
				const self_ = this;

				if(self_.isEmpty(link)) { return }

				if(self_.isObject(link)) {
					// possible to execute multiple links or methods
					Object.keys(link).forEach(key => {
						if (key == 'admin') { self_.$_lnkExec_admin(link.admin) }
						if (key == 'function') { self_.$_lnkExec_function(link.function) }
						if (key == 'ipc') { self_.$_lnkExec_ipc(link.ipc) }
						if (key == 'ipCli') { self_.$_lnkExec_ipCli(link.ipCli) }
						if (key == 'menu') { self_.$_lnkExec_menu(link.menu) }
						if (key == 'method') { self_.$_lnkExec_method(link.method) }
						if (key == 'replace') { self_.$_lnkExec_replace(link.replace) }
						if (key == 'to') { self_.$_lnkExec_to(link.to) }
						if (key == 'url') { self_.$_lnkExec_url(link.url) }
					})
				}

				return
			},
			$_lnkExec_admin(admin) {
				const self_ = this;
				const router_ = self_.$router;

				const operationType_ = admin.operationType

				router_.push({
					to: {
						name: 'admin',
						params: {
							operationType: operationType_
						}
					}
				})
			},
			$_lnkExec_function(func) {
				const self_ = this;
				self_.callFunction(func.name, func.type, func.params)
			},
			$_lnkExec_ipc(ipc) {
				const self_ = this;

				if(ipc.name == 'addPoint') {
					self_.ipcAddPoint(ipc.params.point)
				}
			},
			$_lnkExec_ipCli(ipCli) {
				const self_ = this;

				if(ipCli.name == 'open') { 
					self_.openLink({ url: self_.ipCliUrl })
				}
			},
			$_lnkExec_menu(menu) {
				const self_ = this;
				self_.openMenu(menu)
			},
			$_lnkExec_method(method) {
				const self_ = this;

				if(method.name == 'installPWA') { 
					self_.installPWA()
				}

				if(method.name == 'logout') { 
					self_.logout()
				}

				if(method.name == 'reload') { 
					location.reload()
				}

				if(method.name == 'switchMenuGroup') { 
					const group_ = method.params.menuGroup
					self_.switchMenuGroup(group_)
				}
			},
			$_lnkExec_replace(replace) {
				const self_ = this;
				const router_ = self_.$router;
				router_.replace(replace)
			},
			$_lnkExec_to(to) {
				const self_ = this;
				const router_ = self_.$router;
				router_.push(to)
			},
			$_lnkExec_url(url) {
				window.open(url) 
			}
		}
	}
</script>